import { useState, useCallback } from 'react';

// The verified POS operator lives in sessionStorage (per browser TAB, not
// localStorage) — a shared kiosk browser shouldn't silently carry yesterday's
// operator into a new shift, and multiple lanes on one physical machine
// shouldn't leak identity across tabs. This is attribution state only: it
// never grants any access the logged-in JWT session doesn't already have.
const STORAGE_KEY = 'pos_operator';

const readStored = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const usePosOperator = () => {
  const [state, setState] = useState(readStored);

  const setOperator = useCallback((operator, operatorToken) => {
    const value = { operator, operatorToken, verifiedAt: Date.now() };
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch {
      // sessionStorage unavailable (private mode, etc.) — still usable for this render
    }
    setState(value);
  }, []);

  const clearOperator = useCallback(() => {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
    setState(null);
  }, []);

  return {
    operator: state?.operator || null,
    operatorToken: state?.operatorToken || null,
    setOperator,
    clearOperator
  };
};

export const clearPosOperatorStorage = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
